import { render, staticRenderFns } from "./minLength-editor.vue?vue&type=template&id=dbaa47d2&scoped=true&"
import script from "./minLength-editor.vue?vue&type=script&lang=js&"
export * from "./minLength-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaa47d2",
  null
  
)

export default component.exports